export enum authActionsTypes {
  SIGN_IN = 'core/auth/SIGN_IN',
  SIGN_IN_CLOSED = 'core/auth/SIGN_IN_CLOSED',
}
